<template>
    <div class="upper-parent">
      <div class='same-line itemsContainer inline-block upper-parent-child1'>
        <div class='offer-name'>
          <div v-if="gettersSelectedOffer && gettersSelectedOffer.name">
            {{ this.gettersSelectedOffer.name }}
          </div>
          <div v-if="duplicatedItemName && duplicatedItemName.name" class="item-text">
            {{ duplicatedItemName.name }}
          </div>
        </div>
        <searchable-dropdown
          id='simulation1'
          :list='itemArrays'
          v-model='selectedItem'
          :selectedItem="selectedItem ? this.selectedItem.name : ''">
        </searchable-dropdown>
      </div>
      <div
        class="inline-block upper-parent-child2"
        :style="{'width': '80%', 'overflow-x': 'auto'}">
        <vue-chart
          chart-type='ColumnChart'
          :columns='columns'
          :rows='rows'
          :options='options'>
        </vue-chart>
        <div class="legends-wrapper">
          <div class="legend-marker" v-for='data of barChartLegends'>
            <div class="legend-marker-color" :style="{'background-color': data.color}"></div>
            <span class="legend-label">{{data.label}}</span>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
// import { mockChartData } from './mock'
// import moment from 'moment'
import { mapGetters, mapActions } from 'vuex'
import * as NameSpace from '../../store/NameSpace'
import SearchableDropdown from 'src/components/shared/SearchableDropDown'
// import { CLEAR_FILTER } from 'src/constants/Constants'
import { cloneDeep } from 'lodash'

export default {
  data () {
    return {
      picked: '',
      selectedItemIndex: 0,
      itemArrays: [],
      selectedItem: null,
      windowWidth: 0,
      duplicatedItemName: null,
      homeRouterPath: '/pending-offers'
    }
  },
  watch: {
    chartData () {
      if (typeof this.chartData !== 'undefined' && this.chartData.length === 0) {
        this.pop({
          header: 'Message',
          message: 'No Data Found.',
          type: ''
        })
      }
    },
    selectedItem () {
      if (this.selectedItem.id) {
        this.duplicatedItemName = cloneDeep(this.selectedItem)
        const {storeLevel, period} = this.gettersAggInputData
        this.fetchBarChartData({ itemId: this.selectedItem.id, storeLevel: storeLevel.id, period: period.id })
      }
    }
  },
  computed: {
    ...mapGetters({
      gettersBarChartData: NameSpace.GET_BAR_CHART,
      gettersBarChartLegends: NameSpace.GET_BAR_CHART_LEGENDS,
      gettersOfferDetails: NameSpace.GET_OFFER_ITEMS,
      gettersAggInputData: NameSpace.GET_AGG_INPUT_FILTER_DATA,
      gettersSelectedOffer: NameSpace.GET_SELECTED_OFFER_NAME
    }),
    offerItems () {
      let parentArray = this.gettersOfferDetails.detailedData
      return parentArray.map((arr) => {
        return {name: arr[0], id: arr.itemId}
      })
    },
    columns () {
      return [
        {
          'type': 'string',
          'label': ''
        },
        {
          'type': 'number',
          'label': ''
        },
        {
          type: 'string',
          role: 'style'
        },
        {
          type: 'string',
          role: 'annotation'
        },
        {
          type: 'string',
          role: 'tooltip',
          'p': {
            'html': true
          }
        }
      ]
    },
    rows () {
      return this.getChartsData()
    },
    options () {
      return {
        explorer: {
          actions: ['dragToZoom', 'rightClickToReset'],
          axis: 'horizontal',
          keepInBounds: true,
          maxZoomIn: 4.0
        },
        // isStacked: true,
        lineWidth: 20,
        chartArea: {
          left: 100,
          width: '100%'
        },
        tooltip: {isHtml: true},
        // colors: this.getColors(),
        // trendlines: {
        //   0: {
        //     type: 'linear',
        //     color: 'green',
        //     lineWidth: 3,
        //     opacity: 0.3,
        //     showR2: true,
        //     visibleInLegend: true
        //   }
        // },
        legend: 'none',
        bar: {
          groupWidth: '70%'
        },
        annotations: {
          textStyle: {
            fontSize: 10
          },
          alwaysOutside: true,
          stem: { length: '1' }
        },
        animation: {
          duration: 500,
          easing: 'out',
          startup: true
        },
        title: this.gettersSelectedOffer.name,
        hAxis: {
          title: '',
          textPosition: 'out',
          // format: 'MMM yy',
          textStyle: {
            fontSize: 12
          },
          slantedText: true,
          slantedTextAngle: 90,
          // minValue: new Date(2014, 0),
          // maxValue: new Date(2016, 11),
          gridlines: {
            count: this.getChartsData() ? this.getChartsData().length : 0
          }
        },
        vAxis: {
          title: 'Quantity Per Week',
          // minValue: 0,
          // maxValue: 5000,
          gridlines: {
            color: '#DDD',
            count: 10
          }
        },
        width: this.windowWidth,
        height: 400
      }
    },
    chartData () {
      return this.gettersBarChartData
    },
    barChartLegends () {
      return this.gettersBarChartLegends
    }
  },
  methods: {
    ...mapActions({
      fetchBarChartData: NameSpace.FETCH_BAR_CHART,
      pop: NameSpace.SET_MODAL_CONFIG_ACTION
    }),
    getChartsData () {
      // return chartData.map(data => {
      //   // let date = moment(data.date, 'MM/DD/YYYY')
      //   let annotate = ''
      //   if (data.sales >= 0) {
      //     annotate = data.sales
      //   }
      //   return [data.date, data.sales, annotate.toString()]
      // })
      // console.log('-----------------', this.chartData)
      return this.chartData
    }
    // getColors () {
    //   return [mockChartData.colors.'0', mockChartData.colors.'1', mockChartData.colors.'2']
    // }
  },
  components: {
    SearchableDropdown
  },
  created () {
    console.log(window.innerWidth)
    this.windowWidth = window.innerWidth
    let delta = 0
    switch (this.windowWidth) {
      case 1336:
        this.windowWidth = 1000
        break
      case 1536:
        delta = 536 - 336
        this.windowWidth = 1000 + delta
        break
      case 2400:
        delta = 1400 - 336
        this.windowWidth = 1000 + delta
        break
      case 1280:
        delta = 336 - 1280
        this.windowWidth = 1000 - delta
        break
      default:
        this.windowWidth = 1000
    }
    this.itemArrays = this.offerItems
    this.selectedItem = this.itemArrays[0]
    this.selectedItem = this.itemArrays[0]
    if (!this.selectedItem) {
      this.$router.push(this.homeRouterPath)
    }
    this.duplicatedItemName = cloneDeep(this.selectedItem)
  }
}
</script>
<style scoped>
  .upper-parent {
    flex-direction: row;
    display: flex;
    flex: 1
  }

  .upper-parent-child1 {
    display: flex;
    flex: 2
  }

  .upper-parent-child2 {
    display: flex;
    flex: 8;
    flex-direction: column;
  }
  .marginLeft {
    margin-left: 2rem;
  }
  .legends-wrapper {
    text-align: center;
  }
  .legend-marker {
    display: inline-block;
    padding: 16px 4px 8px 4px;
  }
  .legend-marker-color {
    display: inline-block;
    height: 12px;
    width: 12px;
  }
  .legend-label {
    font-size: 1.4rem;
  }
  .same-line {
    vertical-align: top;
    display: inline-block;
  }
  .itemsContainer {
    background-color: '#f1f1f1';
  }
  .offer-name {
    text-align: center;
    font-size: 1.4rem;
    padding: 1rem;
    background: #f3f3f3;
    color: #4d4d4d;
  }

</style>



// WEBPACK FOOTER //
// PastTrends.vue?5af16cde